import React from 'react';
import { Box } from '@mui/material';
import { Trans } from 'react-i18next';
import { buildSignInLink } from 'utilities/links';
import { ISSUER_INSTALLMENTS_LOGIN_QUERY_PARAM } from 'components/pages/checkout/payment';

const IssuerInstallmentsHeading = ({ userIsLoggedIn = false }) => {
  // this component expects the issuer_installments_enabled feature flag
  // to be checked in the parent component

  const loginLink = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set(ISSUER_INSTALLMENTS_LOGIN_QUERY_PARAM, '1');
    const params = encodeURIComponent(`?${urlSearchParams.toString()}`);

    return `${buildSignInLink({ returnTo: true })}${params}`;
  };

  return (
    <Box
      component="p"
      mb={2}
      data-testid="issuer-installments-heading-component"
    >
      <Trans
        i18nKey={
          userIsLoggedIn
            ? 'checkout.payment.issuerInstallmentsHeadingDefault'
            : 'checkout.payment.issuerInstallmentsHeadingLoggedOut'
        }
      >
        <a href={loginLink()} />
      </Trans>
    </Box>
  );
};

export default IssuerInstallmentsHeading;
